import { ApiClient } from '@/lib/axios/client';
import { DemoRequestDto } from './types';

export class EmailApi {
  static async submitDemoRequest(data: DemoRequestDto): Promise<void> {
    return ApiClient.post<void>('/api/v1/public/demo-request', data);
  }
}
